import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ModalGeneric } from '../../../../ui/generics';
import { OrdersService } from '../../core/services';
import { NotificationService } from '../../../../core/services';
import { OrdersServiceErrorResolverService } from '../../core/services/error-resolvers';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-send-order-mail-modal',
  templateUrl: './send-order-mail-modal.component.html',
  styleUrls: ['./send-order-mail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SendOrderMailModalComponent extends ModalGeneric {

  public orderId: number;
  public loading = false;
  public sending = false;
  public toName = '';
  public toEmail = '';
  public fromEmail = '';
  public replyTo = '';
  public subject = '';
  public body = '';
  public cc: string[] = [];
  private dirty = false;
  private hydrating = false;

  constructor(
    protected readonly cdr: ChangeDetectorRef,
    private readonly ordersService: OrdersService,
    private readonly notify: NotificationService,
    private readonly errors: OrdersServiceErrorResolverService,
    private readonly modal: NzModalService,
  ) {
    super(cdr);
  }

  public open(orderId: number): void {
    this.orderId = orderId;
    this.loading = true;
    this.sending = false;
    this.dirty = false;
    this.hydrating = true;
    this.toName = '';
    this.toEmail = '';
    this.fromEmail = '';
    this.replyTo = '';
    this.subject = '';
    this.body = '';
    this.cc = [];
    this.title = `E-Mail an Lieferanten · Bestellung #${orderId}`;
    super.showModal();

    this.ordersService.getOrderMailPreview(orderId).subscribe({
      next: preview => {
        this.hydrating = true;
        this.toName = preview.toName;
        this.toEmail = preview.toEmail;
        this.fromEmail = preview.fromEmail;
        this.replyTo = preview.replyTo;
        this.subject = preview.subject;
        this.body = preview.body;
        this.loading = false;
        this.cdr.detectChanges();
        this.hydrating = false;
      },
      error: err => {
        this.hydrating = false;
        this.loading = false;
        this.closeModal();
        this.notify.pushError(undefined, this.errors.getMessage(err?.InternalCode || ''));
        this.cdr.markForCheck();
      }
    });
  }

  public recipientLabel(): string {
    if (this.toName && this.toEmail) {
      return `${this.toName} <${this.toEmail}>`;
    }
    return this.toEmail || '';
  }

  public markDirty(): void {
    if (this.hydrating || this.loading) {
      return;
    }
    this.dirty = true;
  }

  public requestClose(): void {
    if (this.sending) {
      return;
    }
    if (!this.dirty) {
      this.closeModal();
      return;
    }
    this.modal.confirm({
      nzTitle: 'Änderungen verwerfen?',
      nzOkText: 'Verwerfen',
      nzCancelText: 'Zurück',
      nzOnOk: () => this.closeModal()
    });
  }

  public send(): void {
    if (this.sending || this.loading || !this.body?.trim()) {
      return;
    }
    this.sending = true;
    this.ordersService.sendOrderMail(this.orderId, {
      cc: this.cc || [],
      body: this.body
    }).subscribe({
      next: mail => {
        this.sending = false;
        this.dirty = false;
        this.closeModal();
        if (mail.status === 'Sent') {
          this.notify.pushSuccess('Erfolgreich', 'E-Mail wurde gesendet');
        } else {
          this.notify.pushError(undefined, 'E-Mail wurde nicht gesendet');
        }
        this.cdr.markForCheck();
      },
      error: err => {
        this.sending = false;
        this.notify.pushError(undefined, this.errors.getMessage(err?.InternalCode || ''));
        this.cdr.markForCheck();
      }
    });
  }
}
